"use client";

import React from "react";

/**
 * KeyholeOverlay - Creates a black overlay with a circular hole in the middle
 * Used for the SPOTLIGHT hazard in Hazard mode
 */
const BlindOverlay: React.FC = () => {
    return (
        <div
            className="absolute inset-0 w-full h-full pointer-events-none z-[10]"
            style={{
                background: `radial-gradient(circle at center, transparent 0%, transparent 5%, rgba(0, 0, 0, 0.97) 10%, rgba(0, 0, 0, 0.99) 30%, rgba(0, 0, 0, 1) 50%)`,
            }}
        />
    );
};

export default BlindOverlay;
